import React from 'react';
import PropTypes from 'prop-types';
import { Formgroup } from './styles';

function FormGroup(props) {
  const { children } = props;
  return <Formgroup {...props}>{children}</Formgroup>;
}

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormGroup;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/form/Group.js